import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TOKEN_LOCAL_STORAGE_KEY } from '../const/app';
import { ROUTES } from '../const/routes';
import { useAppInfo } from '../hooks/useAppInfo';
import { useIsGroupBlocked } from '../hooks/useIsGroupBlocked';
import { useRefetchUser } from '../hooks/useRefetchUser';
import { useSetUserToken } from '../hooks/useSetUserToken';
import { useDeviceStore } from '../stores/DeviceStore';
import { useSystemStore } from '../stores/SystemStore';
import { trcpProxyClient } from '../utils/trcp';
import AppLoader from './AppLoader';

interface Props {
	children: AnyReactElement;
}

const System: React.FC<Props> = ({ children }) => {
	const setToken = useSetUserToken();
	const isGroupBlocked = useIsGroupBlocked();
	// const loginFlowVisible = useSystemStore(state => state.loginFlowVisible);

	const booting = useSystemStore(state => state.booting);
	const setBooting = useSystemStore(state => state.setBooting);
	const user = useSystemStore(state => state.user);
	const token = useSystemStore(state => state.token);
	const { pathname } = useLocation();

	const setServerConfig = useSystemStore(state => state.setServerConfig);
	const serverConfig = useSystemStore(state => state.serverConfig);

	const refetchUser = useRefetchUser();

	const setIsMobileApp = useDeviceStore(state => state.setIsMobileApp);
	const appInfo = useAppInfo();

	const hasUser = !!user;
	const isInApp = pathname.startsWith(ROUTES.APP.ROOT);

	useEffect(() => {
		if (token && !user) {
			refetchUser();
		}
	}, [token]);

	useEffect(() => {
		if (appInfo.loading === false) {
			setIsMobileApp(!!appInfo?.appInfo);
		}
	}, [appInfo]);

	useEffect(() => {
		const localToken = localStorage.getItem(TOKEN_LOCAL_STORAGE_KEY);
		if (localToken) {
			setToken(localToken, true);
		} else {
			setBooting(false);
		}

		const fetch = (credits: number) => {
			trcpProxyClient.app.getServerConfig
				.query()
				.then((c: any) => {
					setServerConfig(c);
				})
				.catch(() => {
					if (credits > 0) {
						setTimeout(() => fetch(credits - 1), 1000);
					}
				});
		};

		fetch(3);
	}, []);

	const isExport = pathname.startsWith('/print/');

	if (appInfo.loading) {
		return <AppLoader />;
	}

	if ((booting || !serverConfig) && !isExport) {
		return <AppLoader />;
	}

	if (isExport) {
		return children;
	}

	if (pathname.startsWith(`${ROUTES.OUT_APP.CONFIR_REGISTRATION_CODE}/`)) {
		return children;
	}

	if (!hasUser && isInApp) {
		return <Navigate to={ROUTES.OUT_APP.LOGIN} />;
	}

	// if (loginFlowVisible && isLoginFlowApp && hasUser) {
	// 	return <Navigate to={ROUTES.APP.ROOT} />;
	// }

	// if (isLoginFlowApp && !loginFlowVisible && hasUser) {
	// 	return <Navigate to={ROUTES.APP.ROOT} />;
	// }

	if (isInApp && !hasUser) {
		return <Navigate to={ROUTES.OUT_APP.LOGIN} />;
	}

	/*
	Routy bez prihlaseni s platnou session
	if (!isInApp && hasUser) {
		return <Navigate to={ROUTES.APP.ROOT} />;
	}
	*/

	if (!isInApp && hasUser && (pathname === '/' || pathname === '/login')) {
		return <Navigate to={ROUTES.APP.ROOT} />;
	}

	if (isGroupBlocked && ![ROUTES.APP.GROUP_BLOCKED, ROUTES.APP.MORE].includes(pathname)) {
		return <Navigate to={ROUTES.APP.GROUP_BLOCKED} />;
	}

	// if (!isInApp && hasUser && !isLoginFlowApp) {
	// 	return <Navigate to={ROUTES.APP.ROOT} />;
	// }

	// if (isInApp && hasUser && !isLoginFlowApp) {
	// 	return <Navigate to={ROUTES.APP.ROOT} />;
	// }

	return children;
};

export default System;
